<template>
  <div class="send-record">
    <div class="main-title">
      <p @click="toList">换电订单</p>
      <p @click="toDetail">>完成进度</p>
      <p>>发送请求记录</p>
    </div>
    <div class="main-body">
      <div class="list">
        <div class="name-label">订单编号：</div>
        <div class="value-label">{{ orderNo }}</div>
      </div>
      <table class="table-custom">
        <thead>
        <tr>
          <th>请求编号</th>
          <th>发送时间</th>
          <th>端口编号</th>
          <th>类型</th>
          <th>内容</th>
          <th>状态</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="item,index in dataList" :key="index">
          <td>{{ item.requestNo }}</td>
          <td>{{ item.createTime }}</td>
          <td>{{ item.chargePortSeqNo ? item.chargePortSeqNo + "号" : "--" }}</td>
          <td>{{ item.sourceType }}</td>
          <td>{{ item.operateType }}</td>
          <td>{{ item.status }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan='6'>暂无数据</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">上一页</div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">下一页</div>
      </div>
      <el-button type="primary" @click="cancelBtn">返回</el-button>

    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";

export default {
  name: 'sendRecordMgmt',
  data() {
    return {
      recordNo: '',
      orderNo: '',
      title: '',
      deviceType: '',
      pageSize: 10,
      beginIndex: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      startTime: '',
      endTime: '',
      chargePortSeqNo: '',
      primaryDeviceNo: '',
      dataList: [],
      searchCondition: '',
      deviceName: '',
      begin: 0
    }
  },
  mounted() {
    if (this.$route.query.recordNo) {
      this.recordNo = this.$route.query.recordNo;
      this.querySendRecord();
    }
    if (this.$route.query.orderNo) {
      this.orderNo = this.$route.query.orderNo;
    }
  },
  methods: {
    cancelBtn() {
      this.$router.push('/managePage/rentOrderMgmt');
    },
    querySendRecord() {
      let self = this;
      let params = {
        recordNo: this.recordNo,
        sourceType: 2,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1
      };
      this.$http.post('/managementPlatform/electricity/queryOrderRequest', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || "查询失败!",
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.querySendRecord();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.querySendRecord();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.querySendRecord();
    },
    toList() {
      this.$router.push("/managePage/batterySwapOrderMgmt");
    },
    toDetail() {
      this.$router.push("/managePage/batterySwapOrderMgmt?recordNo=" + this.recordNo);
    }
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/sendRecordMgmt.vue